import React from 'react';
import { Box, Grid, Card, CardMedia, CardContent, Typography, Skeleton, Divider, Chip } from '@mui/material';

const PlaceDetailsSkeleton = () => (
  <Box>
    {/* Breadcrumb */}
    <Skeleton variant="text" width={180} height={28} />
    <Divider sx={{ my: 2 }} />
    {/* Title */}
    <Skeleton variant="text" width={320} height={48} sx={{ mb: 4 }} />
    <Grid container spacing={4} alignItems="flex-start">
      {/* Main Image */}
      <Grid item xs={12} md={5}>
        <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
          <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 3 }} />
        </Card>
      </Grid>
      {/* Details */}
      <Grid item xs={12} md={7}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton variant="text" width={120} height={28} />
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="text" width={160} height={28} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="rounded" width={60} height={32} />
            <Skeleton variant="rounded" width={60} height={32} />
            <Skeleton variant="rounded" width={60} height={32} />
          </Box>
        </Box>
      </Grid>
    </Grid>
    {/* Description Section */}
    <Box mt={5} mb={3}>
      <Skeleton variant="text" width={180} height={32} sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" width="100%" height={80} />
    </Box>
    {/* Photos Section */}
    <Box mt={4} mb={3}>
      <Skeleton variant="text" width={180} height={32} sx={{ mb: 1 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2 }} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2 }} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2 }} />
        </Grid>
      </Grid>
    </Box>
    {/* Map Section */}
    <Box mt={4} mb={3}>
      <Skeleton variant="text" width={180} height={32} sx={{ mb: 1 }} />
      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardContent>
          <Box
            sx={{
              height: { xs: '250px', md: '400px' },
              width: '100%',
              borderRadius: 2,
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f5f5f5',
            }}
          >
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </Box>
        </CardContent>
      </Card>
    </Box>
  </Box>
);

export default PlaceDetailsSkeleton; 